import { Guid, Nillable } from '@web/utils';

export class AdminOrderBuyer {
  public constructor(
    private readonly data: {
      dignity: string;
      userId?: Nillable<Guid>;
    },
  ) {}

  public get userId(): Nillable<Guid> {
    return this.data.userId;
  }

  public get dignity(): string {
    return this.data.dignity;
  }
}
